import { fetchFormData, fetchJson, HTTP_VERB } from "../../lib/utils"
import authServerConstans from "./authServerConstans"

const authServerApi = {

  login(data) {
    return fetch(`${authServerConstans.host}/oauth/token`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-type": "application/x-www-form-urlencoded; charset=utf-8",
        Authorization: `Basic ${btoa(authServerConstans.serverCredentials)}`
      },
      body: `username=${encodeURIComponent(data.email)}&password=${encodeURIComponent(data.password)}&grant_type=password`
    }).then(response =>
      response.json().then(data => ({
        code: response.status,
        data: data
      }))
    )
  },

  refreshAccessToken(data) {
    return fetch(`${authServerConstans.host}/oauth/token`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-type": "application/x-www-form-urlencoded; charset=utf-8",
        Authorization: `Basic ${btoa(authServerConstans.serverCredentials)}`
      },
      body: `refresh_token=${data.refreshToken}&grant_type=refresh_token`
    })
    .then(response =>
      response.json().then(data => ({
        code: response.status,
        data: data
      }))
    )
    .catch(error => false)
  },

  isAccessTokenValid(data) {
    return fetch(`${authServerConstans.host}/oauth/check_token`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-type": "application/x-www-form-urlencoded; charset=utf-8",
        Authorization: `Basic ${btoa(authServerConstans.serverCredentials)}`
      },
      body: `token=${data.accessToken}`
    })
      .then(response => response.status === 200)
      .catch(() => false)
  },

  createUser(data) {
    return fetch(`${authServerConstans.host}/api/user/`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-type": "application/json",
        Authorization: `Bearer ${data.accessToken}`
      },
      body: JSON.stringify({
        username: data.userData.username,
        name: data.userData.name,
        userRole: data.userData.userRole,
        locale: data.userData.locale
      })
    }).then(response => response.json())
  },

  getUser(data) {
    return fetch(`${authServerConstans.host}/api/user/${data.userId}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-type": "application/json",
        Authorization: `Bearer ${data.accessToken}`
      }
    }).then(response => response.json())
  },

  updateUser(data) {
    return fetch(`${authServerConstans.host}/api/user/${data.userData.id}`, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-type": "application/json",
        Authorization: `Bearer ${data.accessToken}`
      },
      body: JSON.stringify({
        id: data.userData.id,
        username: data.userData.username,
        name: data.userData.name,
        userRole: data.userData.userRole,
        locale: data.userData.locale
      })
    }).then(response => response.json())
  },

  deleteUser(data) {
    return fetch(`${authServerConstans.host}/api/user/${data.userId}`, {
      method: "DELETE",
      headers: {
        "Content-type": "application/json",
        Authorization: `Bearer ${data.accessToken}`
      }
    }).then(response => response.json())
  },

  getUserRoles(data) {
    return fetch(`${authServerConstans.host}/api/user/userRoles`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-type": "application/json",
        Authorization: `Bearer ${data.accessToken}`
      }
    }).then(response => response.json())
  },
  
  resetUserPassword(data) {
    return fetch(`${authServerConstans.host}/api/user/resetPassword/${data.userId}`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-type": "application/json",
        Authorization: `Bearer ${data.accessToken}`
      }
    }).then(response => response.json())
  },

  getUserLocales(data) {
    return fetch(`${authServerConstans.host}/api/user/locales`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-type": "application/json",
        Authorization: `Bearer ${data.accessToken}`
      }
    }).then(response => response.json())
  },

  updateUserPassword(accessToken, userId, password) {

    let data = new FormData()
    data.append("password", password)

    return fetchFormData(
      HTTP_VERB.PUT,
      `${authServerConstans.host}/api/user/updatepassword/${userId}`,
      accessToken,
      data
    )
  },

  getByUsername(accessToken, username) {
    return fetchJson(
      HTTP_VERB.GET, 
      `${authServerConstans.host}/api/user/getByUsername/${username}`,
      accessToken,
      null
    )
  },

  send2FACode(accessToken) {
    return fetchJson(
      HTTP_VERB.POST,
      `${authServerConstans.host}/api/user/send2facode`,
      accessToken,
      null
    )
  },

  validate2FACode(accessToken, code) {

    let data = new FormData()
    data.append("code", code)

    return fetchFormData(
      HTTP_VERB.POST,
      `${authServerConstans.host}/api/user/validatemfacode`,
      accessToken,
      data
    )
  },

  updatePhoneNumber(accessToken, phoneNumber) {

    let data = new FormData()
    data.append("phoneNumber", phoneNumber)

    return fetchFormData(
      HTTP_VERB.PUT,
      `${authServerConstans.host}/api/user/updatephonenumber`,
      accessToken,
      data
    )
  },

  validatePhoneNumberCode(accessToken, code) {

    let data = new FormData()
    data.append("code", code)

    return fetchFormData(
      HTTP_VERB.POST,
      `${authServerConstans.host}/api/user/validatephonenumbercode`,
      accessToken,
      data
    )
  },

  resentPhoneNumberCode(accessToken) {
    return fetchJson(
      HTTP_VERB.POST,
      `${authServerConstans.host}/api/user/resendphonenumbercode`,
      accessToken,
      null
    )
  },

  impersonation(accessToken, organizationId) {

    let data = new FormData()
    data.append("organizationId", organizationId)

    return fetchFormData(
      HTTP_VERB.POST,
      `${authServerConstans.host}/api/user/impersonation`,
      accessToken,
      data
    )
  },

  validatePassword(accessToken, password) {

    let data = new FormData()
    data.append("password", password)

    return fetchFormData(
      HTTP_VERB.POST,
      `${authServerConstans.host}/api/user/validatepassword`,
      accessToken,
      data
    )
  },
}

export default authServerApi



// WEBPACK FOOTER //
// ./src/redux/sagas/authServerApi.js